<template>
	<div class="poll">
	   <v-card-title v-html="$processText(card.title)" />

       <v-card-text>
            <div v-html="$processText(card.wysiwyg)"></div>

            <div class="poll-options">
                <div class="poll-options-option">

                    <div v-if="stats">
                        <div class="poll-options-option-bar">
                            <div class="yes" :style="{height: (yes / 100 * barHeight) + 'px'}"></div>
                        </div>
                        <div class="poll-options-option-bar-count">{{ stats.y }} ({{ yes }}%)</div>
                    </div>

                    <div class="poll-options-option-btn yes" :class="isChosen('yes')" @click="postPoll('yes')">
                        {{ __('button_yes') }} <i class="fas fa-thumbs-up"></i>
                    </div>
                </div>

                <div class="poll-options-option">
                    <div v-if="stats">
                        <div class="poll-options-option-bar">
                            <div class="no" :style="{height: (no / 100 * barHeight) + 'px'}"></div>
                        </div>
                        <div class="poll-options-option-bar-count">{{ stats.n }} ({{ no }}%)</div>
                    </div>

                    <div class="poll-options-option-btn no" :class="isChosen('no')" @click="postPoll('no')">
                        {{ __('button_no') }} <i class="fas fa-thumbs-down"></i>
                    </div>
                </div>
            </div>
       </v-card-text>
	</div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Poll',
    props: ['card'],

    data() {
    	return {
            recommends: null,
            stats: null,
            barHeight: 70
    	}
    },

    created() {
        this.recommends = this.endUser.recommends
        
        axios.get(this.$apiUrl + '/api/end-user/' + this.$route.params.slug + '/client/poll').then(res => {
            this.stats = res.data
        })
    },

    methods: {
       postPoll(answer) {
            this.recommends = answer

            axios
                .post(this.$apiUrl + '/api/feedback/' + this.$route.params.slug + '/' + this.card.id, {
                    feedback: {answer}
                })
                .then(() => {
                    axios.get(this.$apiUrl + '/api/end-user/' + this.$route.params.slug + '/client/poll').then(res => {
                        this.stats = res.data
                    })
                })

            this.$metric({'event': 'poll_interaction', 'InteractionType': answer, 'PollName': this.card.title})
        },

        isChosen(answer) {
            return answer === this.recommends || ! this.recommends ? '' : 'not'
        },
    },

    computed: {
        endUser() {
            return this.$store.state.endUser
        },

    	client() {
            return this.$store.state.client
        },

        yes() {
            return Math.round(this.stats.y / (this.stats.y + this.stats.n) * 100)
        },

        no() {
            return Math.round(this.stats.n / (this.stats.y + this.stats.n) * 100)
        }
    }
}
</script>